import { render, staticRenderFns } from "./Usuario.vue?vue&type=template&id=683cb45a&scoped=true"
import script from "./Usuario.vue?vue&type=script&lang=js"
export * from "./Usuario.vue?vue&type=script&lang=js"
import style0 from "./Usuario.vue?vue&type=style&index=0&id=683cb45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683cb45a",
  null
  
)

export default component.exports